/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo, useState } from 'react'
import { PieChart, Pie, Sector, Cell, Legend, Tooltip } from 'recharts'
import {
  schemeCategory20,
  // schemeCategory20b,
  // schemeCategory20c,
} from 'analytics'
import numeral from 'numeral'
import R from 'ramda'
//  const color = ['#4daf4a', '#377eb8', '#ff7f00', '#984ea3', '#e41a1c']
const color = schemeCategory20
// const color = ['red', 'blue', 'yellow', ...origColor]

const RechartPie = props => {
  const { data, legend = false, applyLableCalc = false } = props
  // const [calc, setCalc] = useState(false)
  const sortedata = useMemo(_ => R.sortBy(d => d.value, data), [data])

  const renderActiveShape = useCallback(
    props => {
      const RADIAN = Math.PI / 180
      const {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value,
        index,
        ...extProps
      } = props
      const smallAngle = endAngle - startAngle < 40

      const sin = Math.sin(-RADIAN * midAngle)
      const cos = Math.cos(-RADIAN * midAngle)
      const sx = cx + (outerRadius + 10) * cos
      const sy = cy + (outerRadius + 10) * sin
      const mx = cx + (outerRadius + 30) * cos
      const my = cy + (outerRadius + 30) * sin
      const ex = mx + (cos >= 0 ? 1 : -1) * 22
      let ey = my
      if (smallAngle && applyLableCalc) {
        const idx = sortedata.findIndex(d => d.name === payload.name)
        if (idx > 1 && sortedata.length > idx + 1) {
          const prev = sortedata[idx - 1]
          // const sum = sortedata.map(d => d.value).reduce((a, b) => a + b)

          if (prev) {
            const prevCert = (prev.value * 100) / 360
            if (prevCert < 20) {
              ey = my - 30
            }
          }
        } else if (idx === 0) {
          ey = my + 30
        }
      }

      const textAnchor = cos >= 0 ? 'start' : 'end'
      return (
        <g>
          {/* <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text> */}
          <Sector
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            startAngle={startAngle}
            endAngle={endAngle}
            fill={fill}
          />

          <path
            d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
            stroke={fill}
            fill="none"
          />
          <circle cx={ex} cy={ey} fill={fill} stroke="none" />
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 12}
            y={ey}
            textAnchor={textAnchor}
            fill="#333"
          >
            {payload.getLabel ? payload.getLabel(payload) : payload.value}
          </text>
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 12}
            y={ey}
            dy={18}
            textAnchor={textAnchor}
            fill="#999"
          >
            ${numeral(value).format('000,000')}-
            {`(${(percent * 100).toFixed(2)}%)`}
          </text>
        </g>
      )
    },
    [applyLableCalc, sortedata]
  )

  const mergeData = R.compose(
    R.map(ca =>
      ca.reduce((a, b) => ({
        ...a,
        ...b,
        value: a.value,
        name: a.name + ' & ' + b.name,
      }))
    ),
    R.map(([_, v]) => v),
    R.toPairs,
    R.groupBy(d => d.value)
  )(sortedata)

  return (
    <div
      style={{
        height: props.height,
        width: props.width,
        display: 'grid',
        minHeight: props.height,
        minWidth: props.width,
        border: '1px solid black',
      }}
    >
      <PieChart width={props.width || 400} height={props.height || 400}>
        {props.title && (
          <text x={10} y={20}>
            {props.title}
          </text>
        )}
        <Pie
          // activeIndex={state.activeIndex}
          activeIndex={mergeData.map((e, i) => i)}
          activeShape={renderActiveShape}
          data={mergeData}
          cx="50%"
          cy="50%"
          // innerRadius={0}
          outerRadius={props.outerRadius || 40}
          fill="#8884d8"
          dataKey="value"
          paddingAngle={2}
          // startAngle={90}
          // endAngle={450}
          // isAnimationActive={false}
          // animationDuration={0}
          // onMouseEnter={onPieEnter}
          // LegendType="rect"
          // label={d => d.getLabel(d)}
          // label
          // labelLine={renderCustomizedLabelLine}
          // label={renderCustomizedLabel}
        >
          {mergeData.map((rec, index) => (
            <Cell key={`cell-${index}`} fill={rec.color || color[index]} />
          ))}
        </Pie>
        {/* <Tooltip /> */}
        {legend && <Legend />}
      </PieChart>
    </div>
  )
}

export default RechartPie

// its not worked properly where has more then 3-4 data
// const renderCustomizedLabel = ({
//   cx,
//   cy,
//   midAngle,
//   innerRadius,
//   outerRadius,
//   value,
//   color,
//   startAngle,
//   endAngle,
//   payload,
//   percent,
// }) => {
//   const RADIAN = Math.PI / 180
//   const diffAngle = endAngle - startAngle
//   const delta = (360 - diffAngle) / 15 - 1
//   const radius = innerRadius + (outerRadius - innerRadius)
//   const x = cx + (radius + Math.abs(delta)) * Math.cos(-midAngle * RADIAN)
//   const y = cy + (radius + delta * delta) * Math.sin(-midAngle * RADIAN)

//   return (
//     <g>
//       <text
//         x={x}
//         y={y}
//         fill={color}
//         textAnchor={x > cx ? 'start' : 'end'}
//         dominantBaseline="central"
//         fontWeight="normal"
//       >
//         {payload.getLabel ? payload.getLabel(payload) : payload.value}
//       </text>
//       <text
//         x={x}
//         y={y}
//         dy={18}
//         dx={10}
//         textAnchor={x > cx ? 'start' : 'end'}
//         fill="#999"
//       >
//         ${numeral(value).format('000,000')}-
//         {`(${(percent * 100).toFixed(2)}%)`}
//       </text>
//     </g>
//   )
// }
// const renderCustomizedLabelLine = props => {
//   const {
//     cx,
//     cy,
//     midAngle,
//     innerRadius,
//     outerRadius,
//     color,
//     startAngle,
//     endAngle,
//   } = props
//   const RADIAN = Math.PI / 180
//   const diffAngle = endAngle - startAngle
//   const radius = innerRadius + (outerRadius - innerRadius)
//   let path = ''
//   for (let i = 0; i < (360 - diffAngle) / 15; i++) {
//     path += `${cx + (radius + i) * Math.cos(-midAngle * RADIAN)},${cy +
//       (radius + i * i) * Math.sin(-midAngle * RADIAN)} `
//   }

//   return <polyline points={path} stroke={color} fill="none" />
// }
